import React, { useEffect, useState } from "react";
import axios from "axios";

const SessionManager = () => {
  const [sessionName, setSessionName] = useState("");
  const [sessions, setSessions] = useState([]);

  const fetchSessions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/sessions/allSessions`
      );
      setSessions(response.data);
    } catch (error) {
      console.error("Error fetching sessions:", error);
    }
  };

  const createSession = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/sessions/createSession`,
        { sessionName },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      setSessions((prev) => [...prev, response.data]);
      alert("Session Created Successfully");
      setSessionName("");
    } catch (error) {
      console.error("Error creating session:", error);
    }
  };

  const deleteSession = async (id) => {
    if (!window.confirm("Are you sure you want to delete this session?")) return;

    try {
      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/api/sessions/deleteSession/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setSessions((prev) => prev.filter((s) => s._id !== id));
      alert("Session Deleted");
    } catch (error) {
      console.error("Error deleting session:", error);
    }
  };

  useEffect(() => {
    fetchSessions();
  }, []);

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">


      <hr className="mb-6" />

      {/* ADD SESSION FORM CARD */}
      <div className="bg-white border shadow-md rounded-lg p-6 mb-10">
        <h2 className="text-2xl font-semibold mb-4">Create New Session</h2>

        <form onSubmit={createSession} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

            {/* Input */}
            <div className="flex flex-col">
              <label className="font-semibold text-gray-700 mb-1">
                Session Name
              </label>
              <input
                type="text"
                value={sessionName}
                onChange={(e) => setSessionName(e.target.value)}
                placeholder="Enter session (e.g., 2024-25)"
                required
                className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div></div>
          </div>

          <button
            type="submit"
            className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            Create Session
          </button>
        </form>
      </div>

      {/* SESSION LIST TITLE */}
      <h1 className="text-3xl font-bold mb-3 text-black-600">
        Sessions List
      </h1>
      <hr className="mb-6" />

      {/* TABLE CARD */}
      <div className="bg-white border shadow-md rounded-lg p-6">

        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border text-center rounded-lg">
            <thead className="bg-gray-200 text-gray-700">
              <tr>
                <th className="border px-4 py-2">Sr No.</th>
                <th className="border px-4 py-2">Session ID</th>
                <th className="border px-4 py-2">Session Name</th>
                <th className="border px-4 py-2">Actions</th>
              </tr>
            </thead>

            <tbody>
              {sessions.length > 0 ? (
                sessions.map((session, index) => (
                  <tr key={session._id} className="hover:bg-gray-100">
                    <td className="border px-4 py-2">{index + 1}</td>

                    {/* ✅ NEW SESSION ID COLUMN */}
                    <td className="border px-4 py-2 text-sm break-all">
                      {session._id}
                    </td>

                    <td className="border px-4 py-2">{session.sessionName}</td>

                    <td className="border px-4 py-2">
                      <button
                        onClick={() => deleteSession(session._id)}
                        className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-500"
                      >
                        <i className="fas fa-trash mr-2"></i>
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="4"   
                    className="border px-4 py-4 text-gray-500 text-center"
                  >
                    No sessions found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default SessionManager;
